import { API_CONFIG } from '../../config/api';

export interface TrendsDataPoint {
  label: string;
  current: number;
  previous?: number | null;
  count: number;
}

export interface GroupTrendsResponse {
  success: boolean;
  data: {
    timeframe: string;
    trends: TrendsDataPoint[];
  };
}

export const getGroupTrends = async (
  token: string,
  groupId: string,
  timeframe: '7d' | '30d' | '90d' | 'all' = '30d',
  compare: boolean = false,
  startDate?: string,
  endDate?: string
): Promise<GroupTrendsResponse> => {
  const params = new URLSearchParams({
    timeframe,
    compare: compare.toString()
  });

  // Add date range params if provided
  if (startDate) {
    params.append('startDate', startDate);
  }
  if (endDate) {
    params.append('endDate', endDate);
  }

  const response = await fetch(`${API_CONFIG.ENDPOINTS.GROUPS}/${groupId}/trends?${params}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch group trends');
  }

  return data;
};
